export const tratamientoColor = {
  idtratamiento_color: null,
  secuencia: '',
  nombre: '',
  imagen: '',
  posicion: '',
  estado: 1,
}